import type { MembershipRecord } from '@libs/data-access/entities'
import { usePlanningTranslation } from '@libs/utils/translations'
import CardFooter from '@spa/scenes/Plannings/components/Card/CardFooter'
import type { LocationModel } from '@spa/scenes/Plannings/redux/models/Location'
import type { TeamModel } from '@spa/scenes/Plannings/redux/models/Team'
import React from 'react'
import type { PropsWithChildren, FC } from 'react'

type Props = {
  team: TeamModel
  shiftTeam: TeamModel
  shiftLocation: LocationModel
  membership: MembershipRecord
}
const ShiftFooter: FC<PropsWithChildren<Props>> = ({
  team,
  shiftTeam,
  shiftLocation,
  membership,
  children
}) => {
  const { t } = usePlanningTranslation()

  const hasDifferentTeam = shiftTeam?.id !== team.id
  const hasDifferentLocation = shiftTeam?.location_id !== team.location_id

  const hasAccess =
    membership?.accessible_location_ids.includes(shiftLocation?.id) ||
    membership?.accessible_team_ids.includes(shiftTeam?.id)

  const restricted = (hasDifferentLocation || hasDifferentTeam) && !hasAccess
  const displayLocation = hasDifferentLocation && shiftLocation

  const displayTeam = hasDifferentTeam && shiftTeam
  const displayTeamAndLocation = displayLocation && displayTeam

  return (
    <CardFooter.Container noBackground={!hasDifferentTeam}>
      {restricted && (
        <CardFooter.Content>
          {t('weekly.card.plannedOnOtherLocation')}
        </CardFooter.Content>
      )}
      {!restricted && (
        <>
          {displayTeamAndLocation && (
            <CardFooter.Content>
              {t('weekly.card.locationWithTeam', {
                locationName: shiftLocation.name,
                teamName: shiftTeam.name
              })}
            </CardFooter.Content>
          )}

          {!displayTeamAndLocation && displayTeam && (
            <CardFooter.Content>
              {t('weekly.card.team', { teamName: shiftTeam.name })}
            </CardFooter.Content>
          )}

          {!displayTeamAndLocation && displayLocation && (
            <CardFooter.Content>
              {t('weekly.card.location', { teamName: shiftLocation.name })}
            </CardFooter.Content>
          )}
        </>
      )}

      <CardFooter.Actions>{children}</CardFooter.Actions>
    </CardFooter.Container>
  )
}

export default ShiftFooter
